import { createGlobalStyle } from 'styled-components';

import { Button } from './Resets';
import { ButtonClass } from './Button';
import FontFaces from './fonts/FontFaces';
import fonts from './fonts';
import { colors } from './design-tokens';
import { media } from './helpers';

const GlobalStyle = createGlobalStyle`
  ${FontFaces};

  *,
  *::before,
  *::after {
    box-sizing: border-box;
  }

  body,
  h1,
  h2,
  h3,
  h4,
  p,
  ul,
  ol,
  li,
  figure,
  figcaption,
  blockquote,
  dl,
  dd {
    margin: 0;
  }

  html {
    min-height: 100%;
    position: relative;
  }

  body {
    ${fonts.bodyMD};
    height: 100%;
    min-height: 100vh;
    overflow-x: none;
    scroll-behavior: smooth;
    text-rendering: optimizeSpeed;

    ${media.max('medium')`
      .menu-open & {
        overflow: hidden;
      }
    `};
  }

  ul,
  ol {
    list-style: none;
    padding: 0;
  }

  h1, .title1 {
    ${fonts.titleLG};
  }

  h2, .title2 {
    ${fonts.titleMD};
  }

  h3, .title3 {
    ${fonts.titleSM};
  }

  .p-big {
    ${fonts.bodyLG};
  }

  a {
    color: ${colors.primary[500]};
    font-weight: 500;
    text-decoration: underline;
    text-decoration-skip-ink: auto;

    * {
      pointer-events: none;
    }

    &:hover {
      color: ${colors.primary[700]};
    }
  }

  img {
    max-width: 100%;
    display: block;
  }

  input,
  button,
  textarea,
  select {
    font: inherit;
  }

  strong, b {
    font-weight: 500;
  }

  #onetrust-banner-sdk {
    border-radius: 0 !important;
  }

  #onetrust-policy {
    margin-top: 35px !important;
  }

  #onetrust-policy-title {
    font-size: 20px !important;
    text-align: center !important;
  }

  #onetrust-policy-text {
    font-size: 13px !important;
    text-align: center !important;
  }

  #onetrust-accept-btn-handler {
    background: ${colors.primary[500]} !important;
    border-radius: 0px !important;
    font-size: 16px !important;
    margin: 8px !important;
    padding: 8px 20px !important;
  }

  #onetrust-pc-btn-handler {
    background: #FFFFFF !important;
    border-radius: 0px !important;
    border: 2px solid ${colors.neutral[900]} !important;
    color: ${colors.neutral[900]} !important;
    font-size: 16px !important;
    margin: 8px !important;
    padding: 8px 20px !important;
    text-decoration: none !important;
  }

  ${Button};
  ${ButtonClass};

  ${media.min('medium')`
    /* .webgl-container : for search */
    .webgl {
      &-container {
        background: none !important;
        position: relative;
      }

      &-hidden {
        display: none;
      }
    }
  `}

  @media (prefers-reduced-motion: reduce) {
    * {
      animation-duration: 0.01ms !important;
      animation-iteration-count: 1 !important;
      transition-duration: 0.01ms !important;
      scroll-behavior: auto !important;
    }
  }
`;

export default GlobalStyle;
